import React from 'react';

const BackButton = ({ onClick }) => {
  return (
    <div className="back-btn" onClick={onClick}>
      ← Back
    </div>
  );
};

export default BackButton;
